import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { SowBirthDateInput, SowMultiSelect, SowSingleSelect } from ".";

import { FormInputField } from "@components-shared/mobile/inputs";
import { InputTypeEnum } from "@data-types/sow/PlayerSowEnums";

export const SowQuestionFields = observer(function SowQuestionFields() {
	const playerSowStore = useContext(PlayerSowStoreContext);

	if (!playerSowStore) {
		return null;
	}

	const getAllQuestions = async () => {
		await playerSowStore.fetchQuestions();

		if (playerSowStore.mappedQuestions.length !== 0) {
			playerSowStore.initializeAnswers(playerSowStore.mappedQuestions);
		}
	};

	useEffect(() => {
		getAllQuestions();
	}, []);

	return (
		<>
			<div>
				<div className="u-type--base u-mar--top--xsml">
					{playerSowStore.mappedQuestions.map((question) => {
						if (question.type === InputTypeEnum.Text) {
							if (question.abrv === "userName") {
								return (
									<FormInputField
										disabled
										name={question.abrv}
										label={question.name}
										className="form__field"
										id={question.id}
										key={question.id}
										labelClassName="u-type--wgt--medium"
									/>
								);
							}
							return (
								<FormInputField
									required
									name={question.abrv}
									label={question.name}
									className="form__field"
									id={question.id}
									key={question.id}
									labelClassName="u-type--wgt--medium"
								/>
							);
						}

						if (question.type === InputTypeEnum.Date) {
							return <SowBirthDateInput label={question.name} />;
						}

						if (
							question.type ===
							InputTypeEnum.CheckboxCustomMultiple
						) {
							return (
								<SowMultiSelect
									question={question}
									key={question.id}
								/>
							);
						}

						if (
							question.type === InputTypeEnum.CheckboxCustomOne ||
							question.type === InputTypeEnum.CheckboxOnly
						) {
							return (
								<SowSingleSelect
									question={question}
									key={question.id}
								/>
							);
						}
					})}
				</div>
			</div>
		</>
	);
});
